import { getSizedImageURL } from '../../core/images';

// https://docs.nosto.com/techdocs/apis/frontend/js-apis/recommendations/sending-product-view-events#sending-product-variant-view-events
// Triggered when a product from a recommendation list gets viewed.
const nostoRecommendedProductViewEvent = async (product_id, ref_id, attribution_type = 'vp') => {
  // console.log(`[ASTR] nostoRecommendedProductViewEvent()`, product_id, recommendation_id, is_quickview);
  return new Promise((resolve) => {
    // https://docs.nosto.com/techdocs/apis/frontend/js-apis/record-attribution
    nostojs(api => api.recordAttribution({ 
        type: attribution_type,
        target: String(product_id), 
        ref: ref_id, 
        refType: 'api',
      }).done()
    );

    resolve();
  });
  /*
  nostojs(api => {
    api.createRecommendationRequest()
      .setProducts([{product_id: String(product_id)}], result_id)
      .setResponseMode('JSON_ORIGINAL')
      .load({skipPageViews: is_quickview})
      .then(response => {
        console.log(`[ASTR] nostoRecommendedProductViewEvent()`, response);
      });
  });*/
};

// https://docs.nosto.com/techdocs/apis/frontend/js-apis/recommendations/sending-product-view-events#sending-product-variant-view-events
// Triggered when the user changes variant on the product page
const nostoRecommendedVariantViewEvent = (product_id, variant_id, is_quickview = false) => {
  nostojs(api => {
    api.createRecommendationRequest({includeTagging:true})
      .setProducts([{product_id: String(product_id), selected_sku_id: String(variant_id)}])
      .setResponseMode('JSON_ORIGINAL')
      .load({skipPageViews: is_quickview})
      .then(response => {
        console.log(`[ASTR] nostoRecommendedVariantViewEvent()`, response);
        
        const event = new CustomEvent('astr-nosto-recommendations-refresh', { 
          detail: {
            message: 'Variant has been selected - refresh Nosto recommendations',
            data: response.recommendations,
          }
        });

        document.dispatchEvent(event);
      });
  });
};

// https://docs.nosto.com/techdocs/apis/frontend/js-apis/recommendations/sending-add-to-cart-events
// Not needed at the moment since we don't have an add to cart button on the recommendation tiles
const nostoRecommendedProductAddToCartEvent = (product_id, recommendation_id) => {
  nostojs(api => {
    api.recommendedProductAddedToCart(String(product_id), recommendation_id);
  });
};

// https://docs.nosto.com/techdocs/implementing-nosto/implement-search/search#search-product-click
// Used in nostoInitGlobalEvents and quicklook/index.js
const nostoRecordSearchClickEvent = (click_location, product_id, product_url) => {
  const product_url_updated = (product_url.substring(0, 4) === 'http') ? product_url : `${window.location.origin}${product_url}`;

  // Promise removed per Nosto team request 2025-06-12
  // return new Promise((resolve) => {
    nostojs(api => {
      api.recordSearchClick(click_location, { productId: String(product_id), url: product_url_updated });
    });

  //   resolve();
  // });
};

const handleProductTileInteraction = async (e) => {
  // e.target.closest('.ns-autocomplete-product-tile')?.removeAttribute('data-ns-hit');
  if (!e.target.closest('[data-product-tile]') || 
      e.target.closest('[data-product-tile-colors]') || 
      e.target.matches('[data-quicklook-button]') || 
      e.target.matches('[data-quicklook-button-mobile]') || 
      e.target.matches('[data-product-swym-wishlist]')) {
    return;
  }

  let click_location = '';
      
  if (e.target.closest('[data-collection-grid]') !== null) {
    click_location = 'category';
  }

  if (e.target.closest('[data-overlay-search-results]') !== null) {
    click_location = 'serp';
  }
  
  if (e.target.closest('.ns-autocomplete-product-tile') !== null) {
    click_location = 'autocomplete';
  }

  if (e.target.closest('[data-nosto-recommendations]') !== null) {
    click_location = 'recommendation';
  }
  console.log('[ASTR] Click location', click_location);
  if (click_location === '') {
    return;
  }

  e.stopPropagation();
  e.preventDefault();
  
  const item = e.target;
  const tile = item.closest('[data-product-tile]');
  const product_id = tile.dataset.productId;
  // Product url can't have querystring
  let product_url = tile.dataset.productUrl;

  // We need to send the full url to Nosto
  product_url = (product_url.substring(0, 4) === 'http') ? product_url : `${window.location.origin}${product_url}`;

  // console.log('[ASTR] Product tile clicked', click_location, product_id, e.target.closest('.nosto_element'), product_url);

  if (click_location === 'recommendation') {
    const nosto_list = e.target.closest('.nosto_element');

    if (nosto_list) {
      const result_id = nosto_list.dataset.resultId || nosto_list.id;

      await nostoRecommendedProductViewEvent(product_id, result_id);
      // window.sessionStorage.setItem('astr-nosto-recommendation-item', JSON.stringify({
      //   product_id,
      //   recommendation_id,
      //   result_id,
      // }));
    }
  } else {
    nostoRecordSearchClickEvent(click_location, product_id, product_url);
    // window.sessionStorage.setItem('astr-nosto-search-item', JSON.stringify({
    //   product_id,
    //   product_url,
    //   click_location,
    // }));
  }

  let redirect_url = tile.querySelector('.product-tile__image').href;

  // If we clicked on an a tag, use its href (link within a promo message for instance)
  if (item.tagName.toLowerCase() === 'a' && item.href) {
    redirect_url = item.href;
  }

  // Preload the main PDP image to reduce LCP
  // If the user clicks quickly and navigates to the product page before the image finishes loading, the browser may still be downloading the image in the background.
  // If the navigation happens after the image is fetched, the image will be loaded from cache and display instantly, improving LCP.
  const main_image = tile.querySelector('[data-product-main-image] img');
  if (main_image) {
    // Determine intended width for preload
    let preloadWidth = 1200;
    if (window.innerWidth <= 768) preloadWidth = 288;
    else if (window.innerWidth <= 1024) preloadWidth = 800;

    const main_image_src = main_image.dataset.originalSrc || main_image.src;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = getSizedImageURL(main_image_src, `${preloadWidth}x`);
    document.head.appendChild(link);
  }

  // Prevent a race condition with navigation. The storage setting might not complete before navigation
  setTimeout(() => window.location.href = redirect_url, 1);
};

// Capture the click event from the product tile for Nosto tracking
const addProductTileListeners = () => {
  let startX = 0;
  let startY = 0;
  const moveThreshold = 10; // pixels to consider as a swipe

  const handleTouchStart = (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  };

  const handleTouchEnd = (e) => {
    // Calculate movement
    const deltaX = Math.abs(e.changedTouches[0].clientX - startX);
    const deltaY = Math.abs(e.changedTouches[0].clientY - startY);

    // Only trigger if movement was minimal (was a tap, not a swipe)
    if (deltaX < moveThreshold && deltaY < moveThreshold) {
      handleProductTileInteraction(e);
    }
  };

  // Regular click for non-touch devices
  document.addEventListener('click', (e) => {
    if (!e.sourceCapabilities || !e.sourceCapabilities.firesTouchEvents) {
      handleProductTileInteraction(e);
    }
  });

  // Touch handling
  document.addEventListener('touchstart', handleTouchStart, { passive: true });
  document.addEventListener('touchend', handleTouchEnd, { passive: false });
};

// Capture and request attribution of the Nosto product view event
const nostoInitGlobalEvents = () => {
  try {
    addProductTileListeners();

    /*
    if (!document.querySelector('body').classList.contains('template-pdp')) {
      return;
    }
    console.log('[ASTR] Nosto init global events', window.sessionStorage.getItem('astr-nosto-search-item'), window.sessionStorage.getItem('astr-nosto-recommendation-item'));
    if (window.sessionStorage.getItem('astr-nosto-recommendation-item') !== null) {
      const nosto_recommendation_item = JSON.parse(window.sessionStorage.getItem('astr-nosto-recommendation-item'));
      console.log('[ASTR] Nosto attribution for recommendation', nosto_recommendation_item);
      nostoRecommendedProductViewEvent(nosto_recommendation_item.product_id, nosto_recommendation_item.recommendation_id, nosto_recommendation_item.result_id);
      window.sessionStorage.removeItem('astr-nosto-recommendation-item');
    }

    if (window.sessionStorage.getItem('astr-nosto-search-item') !== null) {
      const nosto_search_item = JSON.parse(window.sessionStorage.getItem('astr-nosto-search-item'));
      console.log('[ASTR] Nosto attribution for search/plp/autocomplete', nosto_search_item);
      nostoRecordSearchClickEvent(nosto_search_item.click_location, nosto_search_item.product_id, nosto_search_item.product_url);
      window.sessionStorage.removeItem('astr-nosto-search-item');
    }
      */
  } catch (err) {
    console.error(`Failed to init global Nosto events:`, err);
    return;
  }
};

// https://docs.nosto.com/techdocs/apis/frontend/js-apis/recommendations/sending-add-to-cart-events
// In case we have an add to cart button directly on the product tile
// Can also be used for page views per discussion with Nosto team

export {
  nostoInitGlobalEvents,
  nostoRecordSearchClickEvent,
  nostoRecommendedProductViewEvent,
  nostoRecommendedVariantViewEvent,
  nostoRecommendedProductAddToCartEvent,
};
